import { get } from './client';
import type { Webhook, WebhookListResponse, ListWebhooksParams } from '@/types/webhook';

/**
 * Fetch a paginated list of webhooks.
 *
 * @param params - Optional filter and pagination parameters
 * @returns Paginated webhook list
 */
export async function listWebhooks(params?: ListWebhooksParams): Promise<WebhookListResponse> {
  const queryParams: Record<string, string> = {};

  if (params?.page !== undefined) {
    queryParams.page = String(params.page);
  }
  if (params?.limit !== undefined) {
    queryParams.limit = String(params.limit);
  }
  if (params?.eventType) {
    queryParams.eventType = params.eventType;
  }
  if (params?.transactionId) {
    queryParams.transactionId = params.transactionId;
  }
  if (params?.status) {
    queryParams.status = params.status;
  }

  return get<WebhookListResponse>('/webhooks', queryParams);
}

/**
 * Fetch a single webhook by its event ID.
 *
 * @param eventId - The webhook event ID
 * @returns The webhook details
 */
export async function getWebhook(eventId: string): Promise<Webhook> {
  return get<Webhook>(`/webhooks/${eventId}`);
}
